import { useApi } from '@omnipresentgroup/api';
import { IS_E2E } from '@omnipresentgroup/constants';
import { getISOString } from '@omnipresentgroup/design-system';
import type { BulkCompensationTemplateRequest } from '@omnipresentgroup/types';
import { useMutation } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useBulkCompensationDownloadTemplateMutation = () => {
  const { fetchWithToken } = useApi();

  return useMutation({
    mutationFn: ({
      companyId,
      employeesIds,
      compensationType,
    }: BulkCompensationTemplateRequest) => {
      return fetchWithToken({
        path: `${API_BASE}/${API_PATH}/compensation/bulk-template`,
      }).then((res) =>
        res
          .post({
            companyId,
            employeesIds,
            compensationType,
          })
          .text(),
      );
    },
    onSuccess(data, { compensationType }) {
      // Create a link and click it to download the file (skip for e2e tests)
      if (!IS_E2E) {
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: 'text/plain',
          }),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `bulk-${compensationType}-template-${getISOString()}.csv`,
        );
        document.body.append(link);
        link.click();
      }
    },
  });
};
